import { jsx as n, jsxs as w, Fragment as B } from "react/jsx-runtime";
import { forwardRef as p, useContext as b, Fragment as de, useState as C, useLayoutEffect as G, useId as me, useEffect as P, useRef as E, useMemo as j, useCallback as F } from "react";
import { createPortal as ue } from "react-dom";
import { bindForwardedRef as q } from "@givebutter/react-util";
import { pluralize as A } from "@givebutter/util";
import { faSpinnerThird as fe, faSearch as be } from "@fortawesome/pro-regular-svg-icons";
import { faChevronDown as J, faChevronUp as xe, faCheck as W } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as R } from "@fortawesome/react-fontawesome";
import { Root as H, Interactable as pe, Form as he } from "../input/Input.js";
import { Label as ge } from "../label/Label.js";
import { Trigger as Ie, Portal as ye, Content as Se, Root as Ne } from "../popover/Popover.js";
import { Tag as Ce } from "../tag/Tag.js";
import { ComboboxContext as x, ComboboxItemContext as k } from "./ComboboxContext.js";
import { COMBOBOX_SELECTION_KEYS as Z } from "./constants.js";
import { useListboxOptionOnKeyUp as we } from "./useListboxOptionOnKeyUp.js";
import Re from "fuse.js";
import { twMerge as T } from "tailwind-merge";
const Te = ({
  value: e,
  defaultValue: l,
  onChangeValue: r,
  allowMultiple: s = !0,
  onOpenChange: o,
  resource: c = "item",
  plurality: a = "s",
  isError: t = !1,
  disabled: i = !1,
  children: d,
  ...u
}) => {
  const [f, y] = C(e ?? l ?? []), [I, N] = C(!1), [h, S] = C(""), [L, D] = C(!0), U = E(null), z = E(null), [O, m] = C([]), g = j(
    () => new Re([], { keys: ["searchable"], threshold: 0.3 }),
    []
  ), M = F(
    (v) => {
      const Q = v[v.length - 1], X = s ? v : Q ? [Q] : [];
      y(X), r == null || r(X);
    },
    [r, s]
  );
  P(() => {
    typeof e < "u" && y(e);
  }, [e]);
  const $ = F(
    (v) => {
      i || (N(v), o == null || o(v));
    },
    [i, o]
  ), ae = j(
    () => ({
      selectedItems: f,
      setSelectedItems: M,
      isOpen: I,
      setIsOpen: $,
      isError: t,
      query: h,
      setQuery: S,
      useLocalSearch: L,
      setUseLocalSearch: D,
      searchInstance: g,
      searchRef: U,
      listRef: z,
      resource: c,
      plurality: a,
      searchResults: O,
      setSearchResults: m,
      allowMultiple: s,
      disabled: i
    }),
    [
      f,
      I,
      h,
      L,
      g,
      t,
      c,
      a,
      M,
      $,
      O,
      m,
      s,
      i
    ]
  );
  return /* @__PURE__ */ n(x.Provider, { value: ae, ...u, children: /* @__PURE__ */ n(Ne, { open: I, onOpenChange: $, children: d }) });
}, V = p(
  (e, l) => {
    const { disabled: r, setIsOpen: s } = b(x);
    return /* @__PURE__ */ n(
      Ie,
      {
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-label": "Open",
        ref: l,
        tabIndex: 0,
        onKeyUp: (o) => {
          Z.includes(o.key) && s(!0);
        },
        disabled: r,
        asChild: !0,
        ...e
      }
    );
  }
);
V.displayName = "ComboboxTrigger";
const ee = p(
  ({ children: e, placeholder: l = "Search", ...r }, s) => {
    const { disabled: o, selectedItems: c, setSelectedItems: a, isError: t, searchInstance: i } = b(x), u = i.getIndex().docs.filter((f) => c.includes(f.id));
    return /* @__PURE__ */ w(
      H,
      {
        className: "cursor-pointer flex-wrap",
        ref: s,
        isError: t,
        disabled: o,
        ...r,
        children: [
          e,
          u.length === 0 && /* @__PURE__ */ n("span", { className: "text-gray-500", children: l }),
          u.map((f) => /* @__PURE__ */ n(pe, { children: /* @__PURE__ */ n(
            Ce,
            {
              className: T(o && "cursor-not-allowed opacity-70"),
              onClose: (y) => {
                o || (y.preventDefault(), y.stopPropagation(), a(c.filter((I) => I !== f.id)));
              },
              children: f.label
            }
          ) }, f.id))
        ]
      }
    );
  }
);
ee.displayName = "ComboboxTags";
const te = p(
  ({ placeholder: e = "Select", children: l, ...r }, s) => {
    const { disabled: o, selectedItems: c, searchInstance: a, isError: t } = b(x), d = a.getIndex().docs.filter((u) => c.includes(u.id));
    return /* @__PURE__ */ n(
      H,
      {
        className: "flex cursor-pointer justify-between",
        ref: s,
        isError: t,
        disabled: o,
        ...r,
        children: /* @__PURE__ */ n(de, { children: l ?? /* @__PURE__ */ w(B, { children: [
          /* @__PURE__ */ n(oe, { placeholder: e }),
          /* @__PURE__ */ n(R, { icon: J, className: "size-3.5 text-gray-400" })
        ] }) }, d.map((u) => u.id).join(","))
      }
    );
  }
);
te.displayName = "ComboboxSelect";
const oe = ({ placeholder: e = "Select" }) => {
  const { selectedItems: l, searchInstance: r, resource: s, plurality: o } = b(x), a = r.getIndex().docs.filter((i) => l.includes(i.id)), t = a.length;
  return /* @__PURE__ */ w(B, { children: [
    t === 0 && /* @__PURE__ */ n("span", { className: "text-gray-500", children: e }),
    /* @__PURE__ */ w("span", { className: "font-medium", children: [
      t === 1 && /* @__PURE__ */ n("span", { children: a[0].label }),
      t > 1 && `${l.length} ${A(
        l.length,
        s,
        o
      )} selected`
    ] })
  ] });
}, re = p(
  ({ children: e, className: l, ...r }, s) => {
    const { isOpen: o } = b(x), [c, a] = C();
    return G(() => {
      a(new DocumentFragment());
    }, []), o ? /* @__PURE__ */ n(ye, { children: /* @__PURE__ */ n(
      Se,
      {
        asChild: !0,
        ref: s,
        side: "bottom",
        sideOffset: 4,
        className: T(
          "flex w-[--radix-popover-trigger-width] flex-col gap-2 rounded-lg p-1.5",
          l
        ),
        ...r,
        children: /* @__PURE__ */ n(_, { children: e })
      }
    ) }) : c ? ue(e, c) : null;
  }
);
re.displayName = "ComboboxPopover";
const _ = p(
  ({ className: e, ...l }, r) => /* @__PURE__ */ n("div", { ref: r, className: T("flex flex-col gap-2", e), ...l })
);
_.displayName = "ComboboxContent";
const se = p(
  ({ value: e, onChangeValue: l, isLoading: r = !1, ...s }, o) => {
    const c = me(), {
      disabled: a,
      query: t,
      setQuery: i,
      searchRef: d,
      listRef: u,
      setUseLocalSearch: f,
      searchInstance: y,
      setSearchResults: I
    } = b(x);
    return P(() => (i(e ?? ""), f(typeof e > "u"), () => i("")), [e, i, f]), /* @__PURE__ */ w(B, { children: [
      /* @__PURE__ */ w(H, { className: "!w-full", size: "sm", ref: o, children: [
        r ? /* @__PURE__ */ n(R, { icon: fe, className: "size-3 animate-spin text-gray-400" }) : /* @__PURE__ */ n(R, { icon: be, className: "size-3 text-gray-400" }),
        /* @__PURE__ */ n(
          he,
          {
            id: c,
            value: t,
            onChange: (N) => {
              const h = N.target.value;
              i(h), l == null || l(h), typeof e > "u" && I(y.search(h));
            },
            onKeyUp: (N) => {
              var h;
              if (N.key === "ArrowDown") {
                const S = (h = u.current) == null ? void 0 : h.querySelector('[role="option"]');
                S == null || S.focus();
              }
            },
            ref: d,
            disabled: a,
            ...s
          }
        )
      ] }),
      /* @__PURE__ */ n(ge, { htmlFor: c, className: "sr-only", children: "Search" })
    ] });
  }
);
se.displayName = "ComboboxSearch";
const ne = p(
  ({ children: e, className: l, ...r }, s) => {
    const { query: o, listRef: c, useLocalSearch: a, resource: t, plurality: i, searchResults: d } = b(x), u = !!o && a && d.length === 0;
    return /* @__PURE__ */ n("div", { className: "relative", children: /* @__PURE__ */ w(
      "div",
      {
        role: "listbox",
        "aria-label": A(2, t, i),
        className: T("h-full max-h-96 overflow-y-auto", l),
        ref: (f) => {
          c.current = f, q(s, f);
        },
        ...r,
        children: [
          /* @__PURE__ */ n(Le, {}),
          u && /* @__PURE__ */ n(ie, {}),
          e,
          /* @__PURE__ */ n(le, {})
        ]
      }
    ) });
  }
);
ne.displayName = "ComboboxItems";
const ce = p(
  ({ value: e, children: l, className: r, onClick: s, onKeyUp: o, onSelectItem: c, ...a }, t) => {
    const {
      query: i,
      selectedItems: d,
      searchRef: u,
      searchResults: f,
      useLocalSearch: y,
      setSelectedItems: I,
      allowMultiple: N,
      setIsOpen: h
    } = b(x), S = d.includes(e), L = E(null), D = y && i !== "" ? !!f.find((m) => m.item.id === e) : !0, U = we({ ref: L, searchRef: u }), z = j(() => ({ isSelected: S, value: e }), [S, e]), O = F(
      (m) => d.includes(m) ? d.filter((g) => g !== m) : [...d, m],
      [d]
    );
    return D ? /* @__PURE__ */ n(k.Provider, { value: z, children: /* @__PURE__ */ n(
      "div",
      {
        ref: (m) => {
          L.current = m, q(t, m);
        },
        role: "option",
        tabIndex: 0,
        "aria-selected": S,
        className: T(
          "flex items-center gap-2 rounded-md p-1.5",
          "hover:bg-gray-100 focus:outline-none focus-visible:bg-gray-100",
          r
        ),
        onClick: (m) => {
          const g = O(e);
          s == null || s(m), c == null || c({ event: m, selectedItem: e, selectedItems: g }), m.defaultPrevented || I(g), !N && g.length > 0 && h(!1);
        },
        onKeyUp: (m) => {
          if (o == null || o(m), U(m), Z.includes(m.key)) {
            const g = O(e);
            c == null || c({ event: m, selectedItem: e, selectedItems: g }), m.defaultPrevented || I(g), !N && g.length > 0 && h(!1);
          }
        },
        ...a,
        children: l
      }
    ) }) : null;
  }
);
ce.displayName = "ComboboxItem";
const ve = p((e, l) => {
  const r = E(null), { searchInstance: s } = b(x), { value: o } = b(k);
  return G(() => {
    var t;
    !!s.getIndex().docs.find((i) => i.id === o) || s.add({
      id: o,
      searchable: ((t = r.current) == null ? void 0 : t.innerText) ?? "",
      label: e.children
    });
  }, [o, s, e.children]), /* @__PURE__ */ n(
    "span",
    {
      ref: (c) => {
        r.current = c, q(l, c);
      },
      ...e
    }
  );
}), Le = p(
  (e, l) => {
    var a;
    const { listRef: r, searchResults: s } = b(x), [o, c] = C(!1);
    return P(() => {
      if (!r.current) return;
      const t = r.current;
      function i() {
        const d = ((t == null ? void 0 : t.scrollTop) ?? 0) > 0;
        c(d);
      }
      return i(), t == null || t.addEventListener("scroll", i), () => t == null ? void 0 : t.removeEventListener("scroll", i);
    }, [r, (a = r.current) == null ? void 0 : a.scrollHeight, s]), o ? /* @__PURE__ */ n(
      K,
      {
        ref: l,
        className: "absolute left-0 right-0 top-0 flex cursor-default items-center justify-center bg-gradient-to-b from-white to-transparent py-1",
        direction: "up",
        ...e,
        children: /* @__PURE__ */ n(R, { icon: xe, className: "size-3" })
      }
    ) : null;
  }
), le = p(
  (e, l) => {
    var a;
    const { listRef: r, searchResults: s } = b(x), [o, c] = C(!1);
    return P(() => {
      if (!r.current) return;
      const t = r.current;
      function i() {
        const d = t.scrollHeight - t.clientHeight, u = Math.ceil(t.scrollTop) < d;
        c(u);
      }
      return i(), t == null || t.addEventListener("scroll", i), () => t == null ? void 0 : t.removeEventListener("scroll", i);
    }, [r, (a = r.current) == null ? void 0 : a.scrollHeight, s]), o ? /* @__PURE__ */ n(
      K,
      {
        ref: l,
        className: "absolute bottom-0 left-0 right-0 flex cursor-default items-center justify-center bg-gradient-to-t from-white to-transparent py-1",
        direction: "down",
        ...e,
        children: /* @__PURE__ */ n(R, { icon: J, className: "size-3" })
      }
    ) : null;
  }
);
le.displayName = "ComboboxScrollDownButton";
const Y = 10, K = p(
  ({ direction: e, ...l }, r) => {
    const { listRef: s } = b(x), o = E(null), c = F(() => {
      o.current !== null && (window.clearInterval(o.current), o.current = null);
    }, []);
    P(() => () => c());
    const a = F(() => {
      var t, i, d, u;
      e === "up" ? (i = s.current) == null || i.scrollTo({ top: ((t = s.current) == null ? void 0 : t.scrollTop) - Y }) : (u = s.current) == null || u.scrollTo({ top: ((d = s.current) == null ? void 0 : d.scrollTop) + Y });
    }, [s, e]);
    return /* @__PURE__ */ n(
      "div",
      {
        ref: r,
        onPointerEnter: () => {
          o.current === null && (o.current = window.setInterval(a, 50));
        },
        onPointerLeave: () => {
          c();
        },
        ...l
      }
    );
  }
);
K.displayName = "ComboboxScrollButton";
const ie = p(
  ({ children: e, className: l, ...r }, s) => {
    const { resource: o, plurality: c } = b(x), a = `No ${A(0, o, c)} found`;
    return /* @__PURE__ */ n("span", { ref: s, className: T("text-medium block p-1.5", l), ...r, children: e ?? a });
  }
), Oe = () => {
  const { isSelected: e } = b(k);
  return /* @__PURE__ */ n(
    "div",
    {
      className: T(
        "aspect-square h-4 rounded p-0.5",
        !e && "border border-gray-300 bg-white",
        e && "border-transparent bg-blue-500"
      ),
      children: /* @__PURE__ */ n("div", { className: "flex flex-col items-center justify-center text-white", children: e === !0 && /* @__PURE__ */ n(R, { icon: W, size: "xs" }) })
    }
  );
}, Ee = () => {
  const { isSelected: e } = b(k);
  return e ? /* @__PURE__ */ n(R, { icon: W, className: "ml-auto" }) : null;
}, Ge = Te, Je = V, We = ee, Ze = te, Ve = oe, et = re, tt = _, ot = se, rt = ne, st = ce, nt = ve, ct = ie, lt = Ee, it = Oe;
export {
  it as CheckboxIndicator,
  lt as CheckmarkIndicator,
  Oe as ComboboxCheckboxIndicator,
  Ee as ComboboxCheckmarkIndicator,
  _ as ComboboxContent,
  ce as ComboboxItem,
  ve as ComboboxItemText,
  ne as ComboboxItems,
  ie as ComboboxNoneFoundText,
  re as ComboboxPopover,
  Te as ComboboxRoot,
  se as ComboboxSearch,
  te as ComboboxSelect,
  oe as ComboboxSelectValue,
  ee as ComboboxTags,
  V as ComboboxTrigger,
  tt as Content,
  st as Item,
  nt as ItemText,
  rt as Items,
  ct as NoneFoundText,
  et as Popover,
  Ge as Root,
  ot as Search,
  Ze as Select,
  Ve as SelectValue,
  We as Tags,
  Je as Trigger
};
